<template>
  <div class="selectCopy-container">
    <van-nav-bar title="人员选择" left-arrow @click-left="onClickLeft" />
    <div class="search-member">
      <van-search v-model="value" placeholder="搜索" show-action @input="search" />
    </div>
    <div class="member-max">最多选择一百人</div>
    <div class="member-box" v-if="visible">
      <!-- <a-tree
        v-model="checkedKeys"
        :auto-expand-parent="autoExpandParent"
        :tree-data="memberList"
        @select="onCheck"
        :replaceFields="{
          title: 'name',
          key: 'id',
          children: 'childList'
        }"
      /> -->
      <Tree :model="memberList[0]" />
    </div>
    <div class="search-list" v-show="!visible">
      <!-- <div v-for="(item, index) in searchList" :key="index" class="item-list" @click="handleClick(item)">
          <img v-if="item.check" style="width: .4rem;height: .4rem;" src="../assets/radio.png"/>
          <img v-else style="width: .4rem;height: .4rem;" src="../assets/radioCheck.png"/>
          <img style="width: .8rem;height: .8rem; margin-left: .2rem; margin-right: .2rem" v-if="item.avatar" :src="item.avatar">
          <van-icon name="map-marked" v-else />
          <span>{{item.staffName}}</span>
      </div> -->
      <div v-for="(item, index) in searchList" :key="index" class="item-list" @click="handleClick(item)">
        <!-- <img v-if="item.check" style="width: .4rem;height: .4rem;" src="../assets/radio.png"/>
          <img v-else style="width: .4rem;height: .4rem;" src="../assets/radioCheck.png"/>
          <img style="width: .8rem;height: .8rem; margin-left: .2rem; margin-right: .2rem" v-if="item.avatar" :src="item.avatar">
          <van-icon name="map-marked" v-else />
          <span>{{item.staffName}}</span> -->
        <div style="width: 90vw;display: flex;height: 128px;background: #FFFFFF;border-radius: 8px;">
          <div class="clickbox">
            <img v-if="item.check" style="width: .4rem;height: .4rem;" src="../assets/blank.png" />
            <img v-else style="width: .4rem;height: .4rem;" src="../assets/Check.png" />
          </div>
          <div class="concentbox">
            <div style="border-bottom: 1px solid #F3F3F3;min-height: 7vh;display: flex;">
              <div style="padding-top: 0.4rem">
                <img style="width: .8rem;height: .8rem; margin-left: .2rem; margin-right: .2rem" v-if="item.avatar" :src="item.avatar" />
                <van-icon style="width: .8rem;height: .8rem; margin-left: .2rem; margin-right: .2rem" name="map-marked" v-else />
              </div>
              <div style="padding-top: 0.2rem">
                <p>{{ item.name }}</p>
                <p>{{ item.phone }}</p>
              </div>
            </div>
            <div>
              <div class="title">公司名称：{{ item.companyName }}</div>
              <div class="title">部门名称：{{ item.officeName }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <span style="color: #54B2ED; padding-left: .4rem">已选{{ transferData.length > 0 ? transferData.length : 0 }}/100</span>
      <van-button type="info" style="margin-right: .4rem" @click="onConfirm">确定</van-button>
    </div>
    <van-popup v-model="show" class="approve_box" :close-on-click-overlay="false">
      <p class="approve_idea">转交意见</p>
      <van-field v-model="message" class="approve_text" type="textarea" placeholder="请输入转交意见" />
      <div>
        <van-field name="uploader" label="附件">
          <template #input>
            <van-uploader :after-read="(file) => afterRead(file)" :before-delete="(file) => beforeDelete(file)" v-model="approvalFileList" accept="*" :preview-image="false">
              <template>
                <div>
                  <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
                </div>
              </template>
            </van-uploader>
          </template>
        </van-field>
        <div v-for="(i, index) in approvalFileList" :key="index" style="display: flex;justify-content: space-between;align-items: center;padding: 10px 16px">
          <div class="annex-name" @click="preview(i.url)">
            <img style="width: 22px;height: 20px;margin-right:8px" src="../assets/file@2x.png" />
            <div style="display: flex;flex-direction: column">
              <div style="width: 5rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ renderFileName(i) }}</div>
              <div>{{ formatSize(i.size, 2) }}</div>
            </div>
          </div>
          <div class="annex-button" @click="deleteFile(i)">删除</div>
        </div>
      </div>
      <!-- <van-button type="info" @click="show = false;message = ''">取消</van-button>
      <van-button type="info" @click="handleApprove">确认</van-button> -->
      <div class="approve-btns">
        <span
          @click="
            show = false;
            message = '';
          "
          style="height: 0.64rem;font-size: 0.43rem;color: #323233;"
          >取消</span
        >
        <span @click="handleApprove" style="height: 0.64rem;font-size: 0.43rem;color: #1584FF;">确认</span>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getAddressBook, searchStaffList, handleArgee, upload } from "@/axios/services";
import { mapState } from "vuex";
import { Toast } from "vant";
import { v4 as uuidv4 } from "uuid";
import Tree from "./TreeAddressBook.vue";
import { formatSize } from "../utils";
import  VeiBanBridge from '@/utils/bridge'
export default {
  components: {
    Tree,
  },
  data() {
    return {
      value: "",
      memberList: [],
      autoExpandParent: true,
      checkedKeys: [],
      visible: true,
      searchList: [],
      show: false,
      message: "",
      approvalFileList: [],
    };
  },
  watch: {
    value(val) {
      if (val === "") {
        this.visible = true;
      }
    },
  },
  computed: {
    ...mapState(["initialData", "transferData", "approveInfo","fromApp"]),
  },
  mounted() {
    this.getMemebrList();
  },
  methods: {
    formatSize(size, length) {
      return formatSize(size, length);
    },
    renderFileName(item) {
      let str = item?.url?.slice(item?.url?.lastIndexOf("."));
      let name = item?.fileName || item?.name;
      return name + str;
    },
    preview(param) {
      window.location.href = "jsToOc://fujianJump?url=" + param;
    },
    afterRead(file) {
      let content = file.file;
      let formData = new FormData();
      formData.append("file", content);
      const uuid = uuidv4();
      upload(formData).then((res) => {
        this.approvalFileList = this.approvalFileList?.map((item) => {
          if (Object.prototype.hasOwnProperty.call(item, "file")) {
            return { ...res.data.data, key: uuid };
          } else {
            return item;
          }
        });
      });
    },
    beforeDelete(file) {
      this.approvalFileList = this.approvalFileList.filter((item) => {
        if (Object.prototype.hasOwnProperty.call(file, "file")) {
          return item.key !== file.file.key;
        } else {
          return item.key !== file.key;
        }
      });
    },
    handleClick(item) {
      this.searchList.map((i) => {
        if (i.staffId === item.staffId) {
          i.check = !i.check;
          this.checkedKeys = i.check === true ? this.checkedKeys?.filter((item) => item !== i.staffId) : (this.checkedKeys || []).concat([item.staffId]);
          this.$store.commit("setTransferData", item);
        }
      });
      // this.visible = true
      // this.value = ''
      this.getMemebrList();
    },
    getMemebrList() {
      getAddressBook({
        activeState: 0,
        companyId: this.initialData.companyId,
        jobStatus: 0,
        operationalPermissions: 0,
        allShowView: 0,
        returnType: 0,
      }).then((res) => {
        this.memberList = this.handleOptions(res.data.data);
        this.checkedKeys = this.transferData?.map((item) => item.staffId);
      });
    },
    onClickLeft() {
      window.history.back();
      this.$store.commit("setType", false);
    },
    search() {
      this.visible = false;
      const params = {
        companyId: this.initialData.companyId,
        searchKey: this.value,
        returnType: 1,
        activeState: 0,
        allShowView: 0,
        operationalPermissions: 0,
      };
      getAddressBook(params).then((res) => {
        if (res.data.code === 0) {
          let data = res.data.data.map((item) => ({ ...item, check: true, staffId: item.id, staffName: item.name }));
          this.checkedKeys = this.transferData?.map((item) => item.staffId);
          data.map((item) => {
            if (this.checkedKeys?.includes(item.staffId)) {
              item.check = false;
            }
          });
          this.searchList = data;
        }
      });
    },
    onCheck(checkedKeys, e) {
      this.checkedKeys = checkedKeys;
      const data = e.selectedNodes.map((item) => item.data.props.dataRef);
      this.$store.commit("setTransferData", data);
    },
    handleOptions(item) {
      // 给树形数据添加属性
      let that = this;
      function handlePushText(item) {
        for (let i = 0, len = item.length; i < len; i++) {
          let childList = item[i].childList;
          item[i].staffId = item[i].id;
          item[i].staffName = item[i].name;
          // item[i].companyId = that.initialData.companyId;
          if (item[i].type !== 2) {
            item[i].checkable = false;
          }
          if (that.transferData?.length > 0) {
            that.transferData.map((items) => {
              if (items.staffId === item[i].staffId) {
                item[i].isChecked = true;
              }
            });
          }
          if (childList && childList.length > 0) {
            handlePushText(childList);
          }
        }
        return item;
      }
      return handlePushText(item);
    },
    async handleApprove() {
      // if(!this.message) {
      //   Toast.fail('未填写审批意见')
      //   return;
      // }
      const user = await VeiBanBridge.getUserInfo() || {}
      const config = {
          headers: {
            Token: user?.newToken
          }
        }
      
      const params = {
        linkId: this.approveInfo.currentApprover.linkId,
        memberId: this.approveInfo.currentApprover.memberId,
        instanceId: this.approveInfo.instanceId,
        approvalAction: "6",
        content: this.message,
        companyId: this.initialData.companyId,
        staffId: this.approveInfo.currentApprover.staffId,
        sort: this.approveInfo.currentApprover.sort,
        forwardStaffId: this.transferData[0].staffId,
        files: this.approvalFileList
      };
      handleArgee(params, config).then((res) => {
        if (res.data.code === 0) {
          this.show = false;
          this.message = "";
          // window.location.href = "jsToOc://back";
          this.$store.commit("setType", false);
          this.handleBack();
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    onConfirm() {
      this.show = true;
    },
    handleBack() {
      if (this.fromApp) {
        window.location.href = "jsToOc://back";
      } else {
        this.$store.commit('setFromApp', true)
        window.history.go(-1);
      }
    },
  },
};
</script>
<style scoped>
.selectCopy-container {
  width: 100vw;
  min-height: 100vh;
  background: #f9f9f9;
  padding-bottom: 10vh;
}
.member-max {
  height: 0.45rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 0.45rem;
  margin-left: 0.37rem;
}
.member-box {
  width: 92%;
  margin: 0.4rem;
  margin-top: 0.27rem;
  border-radius: 8px;
  background: white;
  font-size: 16px;
  padding: 0.43rem;
}
.search-list {
  width: 90vw;
  /* background: white; */
  min-height: 40vh;
  margin: 0.2rem auto;
  /* padding-left: 0.2rem; */
}
.item-list {
  display: flex;
  align-items: center;
  margin-bottom: 0.1rem;
}
.footer {
  width: 100vw;
  height: 10vh;
  background: white;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.clickbox {
  width: 1rem;
  padding: 0.3rem;
  margin-right: 0.2rem;
  padding-top: 0.5rem;
}
.concentbox {
  width: 89vw;
}
.approve_box {
  width: 8.29rem;
  /* height: 6.29rem; */
  background: #ffffff;
  border-radius: 0.11rem;
}
.approve_idea {
  width: 8.29rem;
  height: 0.96rem;
  font-size: 0.43rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #323233;
  line-height: 0.96rem;
  text-align: center;
  margin: 0;
}
.approve_text {
  width: 6.5rem;
  height: 3.2rem;
  background: #ffffff;
  border-radius: 0.05rem;
  border: 0.01rem solid #dcdde0;
  margin: 0 auto;
}
.approve-btns {
  width: 8.29rem;
  height: 1.28rem;
  background: #ffffff;
  border-radius: 0rem 0rem 0.11rem 0.11rem;
  display: flex;
  line-height: 1.28rem;
  justify-content: space-around;
}
.annex-name {
  display: flex;
  align-items: center;
}
.van-cell /deep/ .van-field__control--custom {
  display: flex;
  justify-content: flex-end;
}
</style>
